import { render, staticRenderFns } from "./CommentsComponent.vue?vue&type=template&id=d20fdb9c&scoped=true"
import script from "./CommentsComponent.vue?vue&type=script&lang=js"
export * from "./CommentsComponent.vue?vue&type=script&lang=js"
import style0 from "./CommentsComponent.vue?vue&type=style&index=0&id=d20fdb9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d20fdb9c",
  null
  
)

export default component.exports